import { Link } from 'react-router-dom';
import { categories, topics } from '@/mocks/topics';

export default function Footer() {
  const year = new Date().getFullYear();
  const hotTopics = topics.slice(0, 4);

  return (
    <footer className="mt-16 w-full bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-radar-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">锐察社</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200">
              以议题为单位，记录行业乱象、消费纠纷与争议事件，帮助读者看清脉络、理性应对。
            </p>
            <p className="mt-4 font-label text-sm text-accent-400">contact@ruicha-observer.com</p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">内容导航</h3>
            <ul className="mt-4 space-y-2.5 font-label text-sm">
              <li><Link to="/" className="text-secondary-200 transition-colors hover:text-accent-400">首页</Link></li>
              <li><Link to="/topics" className="text-secondary-200 transition-colors hover:text-accent-400">议题追踪</Link></li>
              <li><Link to="/guide" className="text-secondary-200 transition-colors hover:text-accent-400">维权指南</Link></li>
              <li><Link to="/about" className="text-secondary-200 transition-colors hover:text-accent-400">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">议题分类</h3>
            <ul className="mt-4 space-y-2.5 font-label text-sm">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/topics?category=${encodeURIComponent(cat.key)}`}
                    className="text-secondary-200 transition-colors hover:text-accent-400"
                  >
                    {cat.key}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">热门议题</h3>
            <ul className="mt-4 space-y-2.5 font-label text-sm">
              {hotTopics.map((topic) => (
                <li key={topic.slug}>
                  <Link
                    to={`/topics/${topic.slug}`}
                    className="line-clamp-1 text-secondary-200 transition-colors hover:text-accent-400"
                  >
                    {topic.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 font-label text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 锐察社 · 内容仅用于议题梳理与信息参考</p>
          <p>站内内容不构成法律意见，具体纠纷请咨询专业人士</p>
        </div>
      </div>
    </footer>
  );
}